var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("HeadbarPage", {
        attrs: { title: "Títulos > Manutenção de Devedor/Codevedor" }
      }),
      _c(
        "v-card",
        { staticClass: "mt-2 mb-3" },
        [
          _c(
            "v-tabs",
            {
              attrs: { color: "primary", grow: "" },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "v-tab",
                [
                  _c("v-icon", { staticClass: "mr-2" }, [
                    _vm._v("mdi-magnify")
                  ]),
                  _vm._v(" Consulta e Download de Modelo ")
                ],
                1
              ),
              _c(
                "v-tab",
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("mdi-upload")]),
                  _vm._v(" Upload e Pré-visualização ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            [
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("ConsultaDownloadModelo", {
                            ref: "consultaDownloadModelo",
                            on: {
                              "titulos-selecionados": _vm.onTitulosSelecionados,
                              "download-modelo": _vm.downloadModelo,
                              "show-error": _vm.showError
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("UploadPreVisualizacao", {
                            attrs: {
                              "titulos-selecionados": _vm.titulosSelecionados
                            },
                            on: {
                              "show-success": _vm.showSuccess,
                              "show-error": _vm.showError,
                              "refazer-busca": _vm.refazerBuscaTitulos
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.snackbar
        ? _c("Snackbar", {
            attrs: {
              mostrarSnackbar: _vm.snackbar,
              corSnackbar: _vm.colorSnackbar,
              mensagemSnackbar: _vm.mensagemSnackbar
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.snackbar = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }